export default {
  'AssignWorkerRow.Wrapper.AssignButton': ({ id, assignedId, image, name }, outlet) => {
    if (id === assignedId) {
      outlet({ selectedId: null, image: null, name: null });
    } else {
      outlet({ selectedId: id, image, name })
    }
  },
  'AssignWorkerRow.Wrapper': ({ displayButton, id, assignedId, image, name }, outlet) => {
    if (displayButton) {
      return;
    }
    if (id === assignedId) {
      outlet({ selectedId: null, image: null, name: null });
    } else {
      outlet({ selectedId: id, image, name });
    }
  }
}